import React from "react";
import AddIcon from "@mui/icons-material/Add";
import XLSXDownload from "../Device/XLSXDownload";
import { path } from "src/constants/path";
import { Link } from "react-router-dom";
import Controls from "src/components/form/controls/Controls";
import DeviceImport from "../Device/DeviceImport";

const WhiteListDeviceControlPanel = ({ children, onUploadSuccess }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <div style={{ display: "flex", justifyContent: "end" }}>
          <Link
            to={{
              pathname: `${path.cmsDevice}/add`,
            }}
          >
            <Controls.Button
              text="Add New"
              variant="outlined"
              startIcon={<AddIcon />}
            />
          </Link>
          <XLSXDownload />
        </div>
        <DeviceImport onUploadSuccess={onUploadSuccess} />
      </div>
    </div>
  );
};

export default WhiteListDeviceControlPanel;
